import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from 'antd';
import MainLayout from './layouts/MainLayout';
import Login from './pages/Login';
import VideoManagement from './pages/VideoManagement';
import PeopleFlowDetection from './pages/PeopleFlowDetection';
import WarningManagement from './pages/WarningManagement';
import PushManagement from './pages/PushManagement';
import SystemManagement from './pages/SystemManagement';
import Statistics from './pages/Statistics';
import NotFound from './pages/NotFound';
import './App.css';

function App() {
  // 简单的身份验证检查，实际项目中应该使用更复杂的身份验证机制
  const isAuthenticated = () => {
    return localStorage.getItem('user') !== null;
  };

  // 受保护的路由组件
  const ProtectedRoute = ({ children }) => {
    if (!isAuthenticated()) {
      return <Navigate to="/login" replace />;
    }
    return children;
  };

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }>
          <Route index element={<Navigate to="/video-management" replace />} />
          <Route path="video-management" element={<VideoManagement />} />
          <Route path="people-flow-detection" element={<PeopleFlowDetection />} />
          <Route path="warning-management" element={<WarningManagement />} />
          <Route path="push-management" element={<PushManagement />} />
          <Route path="system-management" element={<SystemManagement />} />
          <Route path="statistics" element={<Statistics />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
